module.exports = __webpack_public_path__ + "img/terroir-disc-3.914c586a.jpg";